type ErrorLabel = "Authentication Errors" | "Validation Errors" | "Authorization Errors" | "Not Found Errors" | "Internal Errors" | "Miscellaneous Errors" | "Order Errors" | "Unknown Error";

export function getMessageByErrorCode(code: number): ErrorLabel {
    switch (code) {
        case 100205:
        case 100202:
        case 100208:
        case 100211:
        case 100210:
            return "Authentication Errors";

        case 100203:
        case 100212:
        case 100213:
            return "Validation Errors";

        case 100206:
        case 100209:
            return "Authorization Errors";

        case 100204:
            return "Not Found Errors";

        case 100207:
            return "Internal Errors";

        case 100214:
        case 100215:
            return "Miscellaneous Errors";

        case 100216:
        case 100217:
        case 100218:
        case 100219:
            return "Order Errors";

        default:
            return "Unknown Error";
    }
}